import React from "react";
import Typewriter from "typewriter-effect";

function Type() {
  return (
    <Typewriter
      options={{
        strings: [
          "Software Engineer",
          "Full stack react developer",
          "Artificial Intelligence researcher",
          "Pyhton developer",
          "Robotics process automation developer",
          "UI and UX designer",
          "Open Source Contributor",
          "Freelancing projects developer"
        ],
        autoStart: true,
        loop: true,
        deleteSpeed: 45,
      }}
    />
  );
}

export default Type;
